import React, { useEffect, createElement } from 'react';
import { SEOHead } from '../components/SEOHead';
import { HeroSection } from '../components/HeroSection';
import { BrandBanner } from '../components/BrandBanner';
import { ReviewsSection } from '../components/ReviewsSection';
import { BookOnlineSection } from '../components/BookOnlineSection';
import { ServicesSection } from '../components/ServicesSection';
import { RevolutionSection } from '../components/RevolutionSection';
import { FAQSection } from '../components/FAQSection';
import { WhyChooseUsSection } from '../components/WhyChooseUsSection';
export function Home() {
  useEffect(() => {
    // Structured data for Local Business (SEO/AEO)
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'ld-local-business';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'CleaningBusiness',
      name: 'Smith & Jengs',
      description: 'Premium residential and commercial cleaning services in Bicester and Oxfordshire. 100% satisfaction guarantee.',
      url: window.location.origin,
      telephone: ['+441869601439', '+447432285564'],
      email: 'smithsandjengs@yahoo.com',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Bicester',
        addressRegion: 'Oxfordshire',
        addressCountry: 'GB'
      },
      areaServed: {
        '@type': 'GeoCircle',
        geoMidpoint: {
          '@type': 'GeoCoordinates',
          latitude: 51.8994,
          longitude: -1.1516
        },
        geoRadius: '30000'
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5.0',
        reviewCount: '21',
        bestRating: '5'
      },
      sameAs: ['https://www.facebook.com/SmithandJengs/'],
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Cleaning Services',
        itemListElement: [{
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Commercial Cleaning'
          }
        }, {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Basic Home Cleaning'
          }
        }, {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Spring / Deep Cleaning'
          }
        }, {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Move-In / Move-Out Cleaning'
          }
        }, {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Post Renovation Cleaning'
          }
        }, {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Airbnb / Short Term Rental Cleaning'
          }
        }]
      }
    });
    document.head.appendChild(script);
    return () => {
      const existing = document.getElementById('ld-local-business');
      if (existing) existing.remove();
    };
  }, []);
  return <main data-id="element-1273">
      <SEOHead title="Smith & Jengs | Premium Cleaning Services in Bicester & Oxfordshire" description="Professional residential and commercial cleaning services in Bicester and Oxfordshire. Book online in 60 seconds. 100% satisfaction guarantee. 5-star rated on Google." data-id="element-1274" />
      <HeroSection data-id="element-1275" />
      <BrandBanner data-id="element-1276" />
      <ReviewsSection data-id="element-1277" />
      <BookOnlineSection data-id="element-1278" />
      <ServicesSection data-id="element-1279" />
      <RevolutionSection data-id="element-1280" />
      <FAQSection data-id="element-1281" />
      <WhyChooseUsSection data-id="element-1282" />
    </main>;
}